import { useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout";
import { usePrivileges } from "../../../hooks/usePrivileges";
import XsdTable from "../components/XsdTable/XsdTable";
import "../../../feature-styles/xsd.css"
import { FaPalette, FaEnvelope } from "react-icons/fa";
import { TABS_XSD } from "../interfaces/xsd.interface";
function Xsd({certificateTypeId=null}) {
    const [openModal, setOpenModal] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const { hasPrivilege } = usePrivileges();
    const handleSaved = () => {
        setRefreshKey((k) => k + 1);
    };  
    const [activeTab, setActiveTab] = useState(TABS_XSD.CERTIFICATE_CONFIGURATION)
    return (
        <div className="page-container xsd-page">
            <div className="page-header-row">
                <div className="page-title-wrapper">
                    <h2 className="page-title">Catálogo de XSD</h2>
                    <p className="page-subtitle">Administración de esquemas XSD por tipo de certificado.</p>
                </div>

            </div>
            <XsdTable key={refreshKey} certificateTypeId={certificateTypeId} />
        </div>
    );
}

export default Xsd;
